import { StandardButton } from 'base/StandardButton/StandardButton';
import StandardInput from 'base/StandardInput/StandardInput';
import { successNotification } from 'base/notifications/Notifications';
import { t } from 'i18next';
import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../redux/HooksRedux';
import { RootState } from '../../redux/store';
import { capitalizeFirstLetter } from 'utils/helpers';
import validationFunctions from 'utils/validationUtils';
import { ChangeNameValidationSet } from 'utils/validations/ValidationsSet/ChangeNameValidationSet';
import * as userProfileAction from '../../redux/userProfile/userProfileAction';

interface ChangeNameModalI {
  show: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export interface ChangeNameFormDataI {
  first_name: string;
  last_name: string;
}

export const ChangeNameModal = (props: ChangeNameModalI) => {
  const userData = useSelector(
    (state: RootState) => state.userProfile.userProfile
  );
  const [formData, setFormData] = useState<{
    first_name: string;
    last_name: string;
  }>({
    first_name: userData.first_name || '',
    last_name: userData.last_name || ''
  });
  const [showError, setShowError] = useState<boolean>(false);

  const dispatch = useAppDispatch();

  const handleSubmit = async () => {
    const isValid = validationFunctions.checkFormValidity(
      formData,
      ChangeNameValidationSet
    );

    if (!isValid) {
      setShowError(true);
    }

    setShowError(false);

    try {
      const response = await dispatch(
        userProfileAction.updateProfile(formData, userData.user_id?.toString())
      );
      if (response.data.status === 200) {
        successNotification(response.data.message);
        await dispatch(userProfileAction.getProfile());
        props.onCancel();
      } else {
        successNotification(response.data.message);
        await dispatch(userProfileAction.getProfile());
        props.onCancel();
      }
    } catch (error) {
      console.log(error);
      props.onCancel();
    }
  };
  return (
    <Modal
      centered
      size="lg"
      show={props.show}
      dialogClassName="standard-popup "
      id="change_name_model"
      onHide={() => props.onCancel()}
      contentClassName="mx-15"
    >
      <Modal.Header>
        <h3>{t('general.text_3')}</h3>
      </Modal.Header>
      <Modal.Body>
        <div>
          <StandardInput
            className=""
            showError={showError}
            type="text"
            label={t('general.common_text.text_5')}
            placeholder={t('general.common_text.text_5')}
            value={formData?.first_name as string}
            onChange={e =>
              setFormData({ ...formData, first_name: e as string })
            }
            validations={ChangeNameValidationSet.first_name}
          />
        </div>
        <div>
          <StandardInput
            className=""
            showError={showError}
            type="text"
            label={t('general.common_text.text_6')}
            placeholder={t('general.common_text.text_5')}
            value={formData?.last_name as string}
            onChange={e => setFormData({ ...formData, last_name: e as string })}
            validations={ChangeNameValidationSet.last_name}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <StandardButton
          buttonText={capitalizeFirstLetter(t('general.common_text.text_15'))}
          className=""
          onClick={() => props.onCancel()}
          variant="outline-danger"
        />
        <StandardButton
          buttonText={capitalizeFirstLetter(t('general.common_text.text_13'))}
          className=""
          onClick={() => handleSubmit()}
          variant="danger"
        />
      </Modal.Footer>
    </Modal>
  );
};
